window.seminarsChoice = [false, false, false];
window.seminarsChoiceNum = 0;

export function seminarChoice(root = document) {
  const items = root.querySelectorAll('.modal-choice__item');
  const submitBtn = root.querySelector('.modal-submit-btn[data-step="1"]');
  const semNumChoice = root.querySelector('#semNumChoice');
  const semNumInfo = root.querySelector('#semNumInfo');
  const errorSemChoice = root.querySelector('#errorSemChoice');

  const updateSubmitState = () => {
    if (!submitBtn) return;
    const hasActive = root.querySelector('.modal-choice__item.active');
    const disabled = !hasActive;

    submitBtn.disabled = disabled;
    submitBtn.style.opacity = disabled ? '0.5' : '';
    submitBtn.style.pointerEvents = disabled ? 'none' : '';
  };

  items.forEach((item) => {
    item.addEventListener('click', function () {
      errorSemChoice.classList.remove('active');
      this.classList.toggle('active');
      if(seminarsChoice[item.dataset.id]){
        seminarsChoice[item.dataset.id] = false;
        seminarsChoiceNum--;
      } else {
        seminarsChoice[item.dataset.id] = item.dataset.name;
        seminarsChoiceNum++;
      }
      semNumChoice.innerHTML = seminarsChoiceNum?'Выбрано семинаров: '+seminarsChoiceNum:'Семинар не выбран.'
      semNumInfo.innerHTML = seminarsChoiceNum?'Выбрано семинаров: '+seminarsChoiceNum:'Семинар не выбран.'
      //updateSubmitState();
    });
  });

  // Инициализируем состояние кнопки при открытии модалки
  //updateSubmitState();
}
